import { useState } from "react";
import { baseToArrayBufferConversion, blobFileCreator } from "../util/billingUtils";
import { downloadPdfFileCall } from "../api/billing";
import { pendoTrack } from "../util/pendoUtil";
import { updateNewRelicStatsFromSession } from "../util/util";

export const useInvoicePreviewOrDownload = (props) => {
  const [quickBillViewInvoiceError, setQuickBillViewInvoiceError] = useState(false);
  const [billingHistoryViewInvoiceError, setBillingHistoryViewInvoiceError] = useState(false);
  const [downloadInvoiceError, setDownloadInvoiceError] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState(null);

  const getSourceComponentLabel = (sourceComponent) => {
    const SOURCE_COMPONENT_LABELS = {
      quickBill: "Quick Bill",
      default: "Billing History",
    };
    return SOURCE_COMPONENT_LABELS[sourceComponent] || SOURCE_COMPONENT_LABELS.default;
  };

  const getSourceComponentLabelByType = (type) => {
    const ACTION_TYPE_LABELS = {
      ViewInvoice: "View Invoice",
      default: "Download Invoice",
    };
    return ACTION_TYPE_LABELS[type] || ACTION_TYPE_LABELS.default;
  };
  
  const handleInvoiceAction = async (invoiceNumber, action, contractAccount) => {
    try {
      setDownloadInvoiceError(false);
      setBillingHistoryViewInvoiceError(false);
      setQuickBillViewInvoiceError(false);
      setInvoiceNumber(invoiceNumber);
      updateNewRelicStatsFromSession();
      window.newrelic?.addPageAction(action.type, { value: invoiceNumber });
      props.setLoader(true);
      let response = null;
      if (action.type === "ViewInvoice") {
        response = await downloadPdfFileCall(invoiceNumber, contractAccount);
        const arrayBuffer = baseToArrayBufferConversion(response?.data?.data);
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        setTimeout(() => {
          a.click();
        }, 1000);
      } else if (action.type === "DownloadInvoice") {
        response = await downloadPdfFileCall(invoiceNumber, contractAccount);
        const arrayBuffer = baseToArrayBufferConversion(response?.data?.data);
        blobFileCreator(arrayBuffer, invoiceNumber);
      }

      // Extract hardcoded strings into constants
      const PAGE_TITLE = "Customer Portal | Billing And Payment";

      const SOURCE_COMPONENT_LABELS = {
        quickBill: "Quick Bill",
        default: "Billing History",
      };
      const ACTION_TYPE_LABELS = {
        ViewInvoice: "View Invoice",
        DownloadInvoice: "Download Invoice",
      };

      // Get labels dynamically
      const sourceComponentLabel = SOURCE_COMPONENT_LABELS[action.sourceComponent] || SOURCE_COMPONENT_LABELS.default;
      const actionTypeLabel = ACTION_TYPE_LABELS[action.type] || "Unknown Action";

      // Provide a fallback value for statusCode
      const statusCode = response?.data?.statusCode || "Unknown";

      // Use the extracted constants and variables
      pendoTrack(`${PAGE_TITLE} | ${sourceComponentLabel} | ${actionTypeLabel}`, {
        status: "Success",
        invoiceNumber: invoiceNumber,
        statusCode: statusCode,
        accountId: props.accountNumber,
      });
      props.setLoader(false);
    } catch (error) {
      props.setLoader(false);
      pendoTrack(
        `Customer Portal | Billing And Payment | ${getSourceComponentLabel(action.sourceComponent)} | ${getSourceComponentLabelByType(action.type)}`,
        {
          status: "Failed",
          invoiceNumber: invoiceNumber,
          statusCode: error.response?.data?.statusCode,
          accountId: props.accountNumber,
        }
      );
      if (action.sourceComponent === "quickBill") {
        setQuickBillViewInvoiceError(true);
      } else if (action.type === "DownloadInvoice") {
        setDownloadInvoiceError(true);
      } else {
        setBillingHistoryViewInvoiceError(true);
      }
    }
  };
  return {
    handleInvoiceAction,
    invoiceNumber: invoiceNumber,
    quickBillViewInvoiceError,
    downloadInvoiceError,
    billingHistoryViewInvoiceError,
  };
};
